var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boxall"},[_c('div',{staticClass:"title"},[_vm._v("物资集采")]),_c('div',{staticClass:"boxnav"},[_c('div',{staticClass:"bg-image",on:{"click":_vm.handleImageClick}},_vm._l((_vm.images),function(img,i){return _c('img',{key:i,staticClass:"bg-slide",class:{ active: i === _vm.currentIndex },attrs:{"src":img}})}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }